import React, { useState } from 'react'
import VideoPlaceholder from '../../assets/video-content.png'
import { withTheme } from 'theming'
import useTemplateHook from '../template/templateHook'
import LoaderTile from './loaderTile'
import likeIcon from '../../assets/Like.svg'
import viewsIcon from '../../assets/Views.svg'
import dummyImg from '../../assets/dummyImg.png'

const ShortReelContentCard = (props) => {
  const { data, fontFormat, textStyle, isEdit = false, theme, overlayColor } = props

  const { customNavigate } = useTemplateHook()
  const [imgLoaded, setImgLoaded] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = () => {
    if (isEdit) return
    customNavigate('DIRECT', `/shorts/${data?.content_id}`)
  }

  const formatCount = (count) => {
    if (!count && count !== 0) return '0'

    const num = parseInt(count)

    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
    }
    return num.toString()
  }

  return (
    <div
      className="cursor-pointer"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="relative rounded-md overflow-hidden"
        style={{
          width: '100%',
          aspectRatio: '162 / 285',
        }}
      >
        {!imgLoaded && <LoaderTile />}

        <img
          src={dummyImg}
          className="w-full h-full object-cover object-center"
          alt={data?.title}
          style={{ display: !imgLoaded ? 'none' : 'block' }}
          onLoad={() => setImgLoaded(true)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
            currentTarget.src = VideoPlaceholder
          }}
        />

        <div
          className="absolute inset-0 transition-colors duration-500 ease-in-out"
          style={{
            backgroundColor: isHovered ? `${overlayColor}00` : `${overlayColor}80`,
          }}
        />

        <div
          className={`absolute top-0 left-0 p-3 ${isHovered ? 'opacity-0' : 'opacity-100'}`}
          style={{
            ...(textStyle ? { ...textStyle } : { color: theme.c4 }),
          }}
        >
          <p
            className={`text-[10px] md:text-xs ${
              fontFormat ? fontFormat : 'font-bold'
            } line-clamp-3 text-left`}
          >
            {data?.title}
          </p>
        </div>

        <div
          className={`absolute bottom-0 left-0 p-3 text-white transition-opacity duration-500 ease-in-out ${
            isHovered ? 'opacity-0' : 'opacity-100'
          }`}
        >
          <div className="flex items-center gap-1">
            <img src={viewsIcon} alt="views icon" className="w-[12px] md:w-[15px] h-auto" />
            <span className="text-[10px] md:text-xs">{formatCount(data?.view_count || 2700)}</span>
          </div>
        </div>

        <div
          className={`absolute bottom-0 right-0 p-3 text-white transition-opacity duration-500 ease-in-out ${
            isHovered ? 'opacity-0' : 'opacity-100'
          }`}
        >
          <div className="flex items-center gap-1">
            <img src={likeIcon} alt="like icon" className="w-[9px] md:w-[11px] h-auto" />
            <span className="text-[10px] md:text-xs">{formatCount(data?.like_count || 1200)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTheme(ShortReelContentCard)
